/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-useless-catch */
import { API } from "../api";
import { DISTRICT_URL } from "../constants/url.constant";

export const GET_DISTRICTS = "GET_DISTRICTS";

export const getDistricts = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(DISTRICT_URL, {
        params
      });
      //   dispatch({
      //     type: GET_DISTRICTS,
      //     payload: res
      //   });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = { cityTableRows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_DISTRICTS:
      return {
        ...state,
        cityTableColumns: payload.columns,
        cityTableRows: payload.rows,
        totalRows: payload.count
      };
    default:
      return state;
  }
}
